import { cva, type VariantProps } from "class-variance-authority";
import type React from "react";
import type { HTMLAttributes } from "react";
import { cn } from "../../lib/utils";

const defaultClasses = "container--fluid grid gap-unit relative";

const containerVariants = cva("", {
  variants: {
    fullWidth: {
      true: "container--fullwidth relative",
      false: defaultClasses,
    },
    paddingTop: {
      none: "pt-0",
      small: "pt-small",
      medium: "pt-medium",
      large: "pt-large",
    },
    paddingBottom: {
      none: "pb-0",
      small: "pb-small",
      medium: "pb-medium",
      large: "pb-large",
    },
  },
  defaultVariants: {
    fullWidth: false,
    paddingTop: "medium",
    paddingBottom: "medium",
  },
});

export interface ContainerProps
  extends VariantProps<typeof containerVariants>,
    Omit<HTMLAttributes<HTMLElement>, "className"> {
  fullWidth?: boolean;
  outerContainerOnly?: boolean;
  children: React.ReactNode;
  className?: string;
  id?: string;
  testId?: string;
}

/**
 * ContainerSection component
 * @param props : ContainerProps
 * @constructor
 */
export function Container({
  fullWidth,
  outerContainerOnly,
  children,
  className,
  id,
  paddingTop,
  paddingBottom,
  testId = "container",
  ...props
}: Readonly<ContainerProps>) {
  const containerClasses = cn(
    containerVariants({
      fullWidth: !!fullWidth,
      paddingTop,
      paddingBottom,
      className,
    })
  );

  return (
    <section
      className={containerClasses}
      data-testid={testId || "container"}
      id={id}
      {...props}
    >
      {!outerContainerOnly && fullWidth ? (
        <div className={defaultClasses}>{children}</div>
      ) : (
        children
      )}
    </section>
  );
}
